/**
 * The sectors and the routes share one drag context, because a route is moved
 * by dropping it on a cliff in the column to the left. Two kinds of thing can
 * therefore be dropped on, and a route's id is a bare number — so the sectors'
 * drop ids are prefixed, and that prefix is what tells a reorder (dropped on
 * another route) from a move (dropped on a sector).
 */

const SECTOR = 'sector:';

export function sectorDropId(sectorId: string): string {
  return `${SECTOR}${sectorId}`;
}

/** The sector a drop landed on, or null when it landed on something else. */
export function sectorFromDropId(dropId: string | number | null | undefined): string | null {
  const value = String(dropId ?? '');

  return value.startsWith(SECTOR) ? value.slice(SECTOR.length) : null;
}
